<div [formGroup]="permissionForm" class="form-container">
  <div class="section-1">
    <p class="section-title">
      Student's Details
    </p>
    <div class="student-form">
      <div class="form-item">
        <p>
          First name
        </p>
        <input pInputText formControlName="studentFirstName">
      </div>

      <div class="form-item">
        <p>
          Family name
        </p>
        <input pInputText formControlName="studentFamilyName">
      </div>

      <div class="form-item">
        <p>
          Gender
        </p>
        <p-dropdown *ngIf="genders.length > 0" optionLabel="name" [options]="genders" formControlName="studentGender">
        </p-dropdown>
      </div>

      <div class="form-item">
        <p>
          Nationality
        </p>
        <p-dropdown *ngIf="nationalities.length > 0" optionLabel="name" [options]="nationalities"
          formControlName="studentNationality"></p-dropdown>
      </div>

      <div class="form-item">
        <p>
          First Language
        </p>
        <p-dropdown *ngIf="languages.length > 0" optionLabel="name" [options]="languages"
          formControlName="studentFirstLanguage"></p-dropdown>
      </div>

      <div class="form-item">
        <p>
          Date of birth
        </p>
        <p-calendar [locale]="locale" formControlName="studentDateOfBirth" [monthNavigator]="true"
          [yearNavigator]="true" yearRange="1990:2020" dateFormat="dd/mm/yy" [showOtherMonths]="false"></p-calendar>
      </div>

      <div class="form-item">
        <p>
          Passport Number
        </p>
        <input pInputText formControlName="studentPassportNumber">
      </div>
      <div class="form-item">
        <p>
          Passport Expiry Date
        </p>
        <p-calendar [locale]="locale" formControlName="studentPassportExpiryDate" [monthNavigator]="true"
          [yearNavigator]="true" yearRange="1990:2020" dateFormat="dd/mm/yy" [showOtherMonths]="false"></p-calendar>
      </div>
    </div>
  </div>
  <div class="section-2">


  <p class="section-title">
    Parent's Details (and emergency contact)
  </p>
  <p>
    Parent 1:
  </p>
  <div class="parent1-form">
    <div class="form-item">
      <p>
        Title
      </p>
      <input pInputText formControlName="parent1Title">
    </div>

    <div class="form-item">
      <p>
        First Name
      </p>
      <input pInputText formControlName="parent1FirstName">
    </div>
    <div class="form-item">
      <p>
        Family Name
      </p>
      <input pInputText formControlName="parent1FamilyName">
    </div>

    <div class="form-item">
      <p>
        Relationship to child
      </p>
      <input pInputText formControlName="parent1RelationshipToStudent">
    </div>

    <div class="form-item">
      <p>
        First language
      </p>
      <p-dropdown *ngIf="languages.length > 0" optionLabel="name" [options]="languages"
        formControlName="parent1FirstLanguage"></p-dropdown>
    </div>

    <div class="form-item">
      <p>
        Level of English
      </p>
      <input pInputText formControlName="parent1LevelOfEnglish">
    </div>

    <div class="form-item">
      <p>
        Address
      </p>
      <input pInputText formControlName="parent1Address">
    </div>

    <div class="form-item">
      <p>
        Mobile phone
      </p>
      <input pInputText formControlName="parent1MobileNumber">
    </div>

    <div class="form-item">
      <p>
        Email
      </p>
      <input pInputText formControlName="parent1Email">
    </div>
  </div>
  <p>
    Parent 2:
  </p>
  <div class="parent2-form">
    <div class="form-item">
      <p>
        Title
      </p>
      <input pInputText formControlName="parent2Title">
    </div>

    <div class="form-item">
      <p>
        First Name
      </p>
      <input pInputText formControlName="parent2FirstName">
    </div>

    <div class="form-item">
      <p>
        Family Name
      </p>
      <input pInputText formControlName="parent2FamilyName">
    </div>

    <div class="form-item">
      <p>
        Relationship to child
      </p>
      <input pInputText formControlName="parent2RelationshipToStudent">
    </div>

    <div class="form-item">
      <p>
        First language
      </p>
      <p-dropdown *ngIf="languages.length > 0" optionLabel="name" [options]="languages"
        formControlName="parent2FirstLanguage"></p-dropdown>
    </div>

    <div class="form-item">
      <p>
        Level of English
      </p>
      <input pInputText formControlName="parent2LevelOfEnglish">
    </div>

    <div class="form-item">
      <p>
        Address
      </p>
      <input pInputText formControlName="parent2Address">
    </div>

    <div class="form-item">
      <p>
        Mobile phone
      </p>
      <input pInputText formControlName="parent2MobileNumber">
    </div>
    <div class="form-item">
      <p>
        Email
      </p>
      <input pInputText formControlName="parent2Email">
    </div>
  </div>
  <p>
    Students under 18 years old are minors in UK law. If your child is 16 or 17 and is studying on an adult course, he
    or
    she will only be supervised
    during lessons and any planned activities that the student hassigned up for.
  </p>
</div>
  <div class="section-3">
    <p class="section-title">
      Medical Emergencies
    </p>
    <p>
      The authority of a parent/guardian is required before emergency medical, surgical or dental treatment can be
      carried
      out in the event of a serious accident or illness. To avoid delay in arranging emergency treatment if permission
      cannot, for any reason,
      be obtained, we recommend permission is given to ETC in advance by declaring authority on this permission form.
    </p>
    <div>
      <span>
        I give permission for the senior staff at ETC International College to arrange emergency medical, surgical or
        dental treatment for my child if necessary.
      </span>
      <p-checkbox [formControl]="permissionForm.controls['permitMedicalTreatment'] | formControl" [binary]="true"></p-checkbox>
    </div>
    <div>
      <span>
        I confirm I have disclosed all medical problems on the enrolment form.
      </span>
      <p-checkbox [formControl]="permissionForm.controls['confirmAllMedicalProblemDisclosure'] | formControl" [binary]="true">
      </p-checkbox>
    </div>

    <div>
      <span>
        If not, please add details here:
      </span>
      <input pInputText formControlName="extraMedicalProblemDetail">
    </div>
  </div>
  <div class="section-4">
    <p class="section-title">
      Activities
    </p>
    <div>
      <span>
        I give permission for my child aged 12-15 to participate in the ETC junior activity programme which takes place
        on
        and off ETC premises using transport arranged by ETC where necessary.
      </span>
      <p-checkbox [formControl]="permissionForm.controls['permitParticipationToJuniorActivity'] | formControl" [binary]="true">
      </p-checkbox>
    </div>

    <div>
      <span>
        My child aged 16-17 understands that any activities they wish to participate in need to be signed up for in
        advance on a first come, first serve basis and agrees to attend all activities they have signed up for.
      </span>
      <p-checkbox [formControl]="permissionForm.controls['confirm16To17ActivityConditions'] | formControl" [binary]="true"></p-checkbox>
    </div>
  </div>
  <div class="section-5">
    <p class="section-title">
      Media
    </p>
    <p>
      I understand that ETC may take photographs or video clips of students during class or leisure activities and that
      these images may be used in the college’s publicity or social media.
    </p>
    <p>
      I give consent for images and videos to be used in the following ways:
    </p>
    <ul>
      <li>
        <div>
          <span>
            Allow publishing print material
          </span>
          <p-checkbox [formControl]="permissionForm.controls['allowPublishingPrintMaterial'] | formControl" [binary]="true">
          </p-checkbox>
        </div>
      </li>
      <li>
        <div>
          <span>
            Allow publishing social media
          </span>
          <p-checkbox [formControl]="permissionForm.controls['allowPublishingSocialMedia'] | formControl" [binary]="true"></p-checkbox>
        </div>
      </li>
      <li>
        <div>
          <span>
            Allow publishing videos
          </span>
          <p-checkbox [formControl]="permissionForm.controls['allowPublishingVideos']  | formControl" [binary]="true"></p-checkbox>
          <span>(videos may be posted on ETC partener websites, social media YouTube).</span>
        </div>
      </li>
      <li>
        <div>
          <span>
            Allow publishing ETC website
          </span>
          <p-checkbox [formControl]="permissionForm.controls['allowPublishingEtcWebsite'] | formControl" [binary]="true"></p-checkbox>
        </div>
      </li>
    </ul>
  </div>
  <div class="section-6">
    <p class="section-title">
      Transportation
    </p>
    <p>
      Door-to-door transport between the student’s accommodation and the school is included in the junior programme
      automatically for students aged 13 and under. If you wish to make your own travel arrangements for your child
      please
      tick the boxes below. Please note an airport transfer is compulsory for junior students under 16 travelling
      unaccompanied by an adult.
    </p>
    <div>
      <span>
        I wish to make my own arrangements for the transport between my child’s accommodation and the school
      </span>
      <p-checkbox [formControl]="permissionForm.controls['makeOwnTransportFromAccommodationToSchool'] | formControl" [binary]="true">
      </p-checkbox>
    </div>

    <div>
      <span>
        I wish to make my own arrangements for transport from and to the airport for my child (16+ only)
      </span>
      <p-checkbox [formControl]="permissionForm.controls['makeOwnTransportFromAndToAirport'] | formControl" [binary]="true">
      </p-checkbox>
    </div>

    <div>
      <span>
        I consent to my child travelling by any form of public transport and or in a coach hired or owned by ETC
        International College with a driver that is authorised by law and insured to drive
      </span>
      <p-checkbox [formControl]="permissionForm.controls['allowPublicTransport'] | formControl" [binary]="true"></p-checkbox>
    </div>
  </div>
  <div class="section-7">
    <div class="section-title-container">
      <span class="section-title">
        Accommodation
      </span>
      <span>
        (please tick as appropriate to the booking)
      </span>
    </div>

    <div>
      <span>
        My child understands that he/she must follow the rules of the accommodation
      </span>
      <p-checkbox [formControl]="permissionForm.controls['agreeToFollowAccommodationRules'] | formControl" [binary]="true"></p-checkbox>
    </div>

    <ul>
      <li>
        <div>
          <span>
            I agree for my child to stay in homestay accommodation, arranged by ETC International College
          </span>
          <p-checkbox [formControl]="permissionForm.controls['stayInHomestayAccommodation'] | formControl" [binary]="true"></p-checkbox>
        </div>
      </li>
      <li>
        <div>
          <span>
            I agree for my child to stay in residential accommodation, arranged by ETC International College
          </span>
          <p-checkbox [formControl]="permissionForm.controls['stayInResidentialAccommodation'] | formControl" [binary]="true">
          </p-checkbox>
        </div>
      </li>
      <li>
        <div>
          <span>
            I / my agent will be making my own arrangements for my child’s accommodation and I understand that a
            supplement for any
            meals provided at the College and welfare/security checks of the accommodation (DBS) will be included in the
            invoice automatically
          </span>
          <p-checkbox [formControl]="permissionForm.controls['stayInOwnAccommodation'] | formControl" [binary]="true"></p-checkbox>
        </div>
      </li>
    </ul>
    <p>
      The details of accommodation are as follows:
    </p>
    <div class="accommodation-form">
      <div>
        <p class="form-item">
          Full name of responsible adult in the accommodation aged at least 21+ years of age:
        </p>
        <input pInputText formControlName="ownAccommodationResponsibleName">
      </div>

      <div class="form-item">
        <p>
          Date of birth
        </p>
        <p-calendar [locale]="locale" formControlName="ownAccommodationResponsibleBirthDate" [monthNavigator]="true"
          [yearNavigator]="true" yearRange="1990:2020" dateFormat="dd/mm/yy" [showOtherMonths]="false"></p-calendar>
      </div>

      <div class="form-item">
        <p>
          Relationship to the child
        </p>
        <input pInputText formControlName="ownAccommodationResponsibleRelationshipToChild">
      </div>

      <div class="form-item">
        <p>
          Address
        </p>
        <input pInputText formControlName="ownAccommodationResponsibleAddress">
      </div>

      <div class="form-item">
        <p>
          Mobile phone
        </p>
        <input pInputText formControlName="ownAccommodationResponsiblePhoneNumber">
      </div>

      <div class="form-item">
        <p>
          Email
        </p>
        <input pInputText formControlName="ownAccommodationResponsibleEmail">
      </div>
    </div>
  </div>
  <div class="section-8">
    <p class="section-title">
      Classes with over 18s
    </p>
    <div>
      <span>
        All students are placed in classes with those of a similar age and English Level to enable them to get the most
        out of their time at ETC. We mix the nationalities of students in our classes in order to encourage students to
        speak English at all times. Sometimes in order to mix these classes and to benefit the students we may want to
        place a junior student aged 16 or 17 in a class with other students over the age of 18. If you are happy for us
        to
        place your child in a class of students over the age of 18, please confirm your permission by ticking the box
      </span>
      <p-checkbox [formControl]="permissionForm.controls['allowJoiningClassWithOver18'] | formControl" [binary]="true"></p-checkbox>
    </div>

    <p>
      Permission to go out unsupervised (16 & 17 year olds only)
    </p>
    <div>
      <span>
        I give permission for my child to leave their accommodation unsupervised during their free time. I have
        explained to my child that they must partake in all elements of their programme and must return to their
        accommodation (Students who are under 16 may not leave their accommodation without the supervision of an ETC
        authorised adult): 16 &amp; 17 years curfew: 10:00pm
      </span>
      <p-checkbox [formControl]="permissionForm.controls['allowGoingOutUnsupervised'] | formControl" [binary]="true"></p-checkbox>
    </div>
  </div>
  <div class="section-9">
    <p class="section-title">
      Long Term Students (16 & 17 year olds only)
    </p>
    <p>
      Details of student's doctor in home country:
    </p>
    <div class="doctor-form">

      <div class="form-item">
        <p>
          Title
        </p>
        <input pInputText formControlName="doctorTitle">
      </div>

      <div class="form-item">
        <p>
          First Name
        </p>
        <input pInputText formControlName="doctorFirstName">
      </div>

      <div class="form-item">
        <p>
          Family Name
        </p>
        <input pInputText formControlName="doctorFamilyName">
      </div>

      <div class="form-item">
        <p>
          Address
        </p>
        <input pInputText formControlName="doctorAddress">
      </div>

      <div class="form-item">
        <p>
          Telephone
        </p>
        <input pInputText formControlName="doctorPhoneNumber">
      </div>

      <div class="form-item">
        <p>
          Email
        </p>
        <input pInputText formControlName="doctorEmail">
      </div>

      <div class="form-item">
        <p>
          When did your child last have a tetanus injection? Date:
        </p>
        <p-calendar [locale]="locale" formControlName="lastTetanusInjectionDate" [monthNavigator]="true"
          [yearNavigator]="true" yearRange="1990:2020" dateFormat="dd/mm/yy" [showOtherMonths]="false"></p-calendar>
      </div>
    </div>

    <div>
      <span>
        I give permission for my child to be registered with a doctor (General Practitioner) in the UK
      </span>
      <p-checkbox [formControl]="permissionForm.controls['allowRegisteringChildWithDoctor'] | formControl" [binary]="true"></p-checkbox>
    </div>
  </div>
  <div class="section-10">
    <p class="section-title">
      Adult Courses (16 & 17 year olds only)
    </p>
    <p>
      I understand that:
    </p>
    <ul>
      <li>
        my child will come in to regular contact with other students over the age of 18 in class and during leisure
        activities.
      </li>
      <li>
        my child is responsible for buying their own lunch during the week.
      </li>
      <li>
        if they are located in an adult residence I understand this accommodation is self-catered and my child will be
        responsible for buying their own breakfast, lunch and dinner.
      </li>
      <li>
        there are certain British laws (e.g. related to smoking and drinking alcohol) that apply to people under the age
        of 18. As a consequence there may be some leisure activities in which my child cannot take part in because of
        their age.
      </li>
    </ul>
  </div>
  <div class="section-11">
    <p class="section-title">
      Declaration
    </p>
    <p>
      If any of the boxes have not been ticked, we will assume you have read and understood the statements and do not
      give permission in these areas.
    </p>
    <p>
      I confirm all information given is correct to my knowledge.
    </p>
    <p>
      By signing this form you agree for your child’s data to be processed and shared with 3rd parties only for the
      purpose of securing the booking i.e. with relevant accommodation and airport transfer providers etc.
    </p>
    <p>
      You must be the person who holds parental responsibility and aged over 21 years, the agent is not eligible to
      complete this form.
    </p>
    <div class="declaration-form">

      <div class="form-item">
        <p>
          Full Name
        </p>
        <input pInputText formControlName="parentalResponsibleFullName">
      </div>

      <div class="form-item">
        <p>
          Tel
        </p>
        <input pInputText formControlName="parentalResponsiblePhoneNumber">
      </div>

      <div class="form-item">
        <p>
          Relationship to the student
        </p>
        <input pInputText formControlName="parentalResponsibleRelationshipToStudent">
      </div>

      <div class="form-item">
        <p>
          Full address
        </p>
        <input pInputText formControlName="parentalResponsibleFullAddress">
      </div>

      <div class="form-item">
        <p>
          Parental Signature
        </p>
        <input pInputText formControlName="parentalSignature">
      </div>
    </div>
  </div>
  <div class="send-button-container">
    <p-button label="Send Form" (onClick)="sendForm()"></p-button>
  </div>
</div>